export const BUDDY_REQUEST_FORM = 'buddyRequestForm'
